
import { Component, Emit, Prop } from 'vue-property-decorator'
import AppModal from '@/components/AppModal.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ChildComponentMixin } from '@/mixins'

@Component({
    components: {
        AppModal,
        FontAwesomeIcon,
    },
})

export default class PartnerFormSavingModal extends ChildComponentMixin {
    @Prop() public showCreatingPartnerModal: boolean = false
    @Prop() public showDeactivatingPartnerModal: boolean = false

    @Emit('closeCreatingModal')
    public onCloseCreatingModal(e: Event) {
        return e
    }

    @Emit('closeDeactivatingModal')
    public onCloseDeactivatingModal(e: Event) {
        return e
    }

    @Emit('cancel')
    public onCancelDeactivatingModal(e: Event) {
        return e
    }
}
